import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AllNotifications from "./AllNotifications";
import MyTickets from "./MyTickets";
import AllTickets from "./AllTickets";
import { UserContext } from "../../context/UserContext";
import { trackEventMatomo } from "../../helpers/matomo";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Solicitante from "./Solicitante";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export type tabType = {
  isActiveObject: string,
  object: string[]
};

export default function NotificationsTabs() {
  const { setPageNumber, setItensPerPage, setTotalItens, userData } = useContext(UserContext);
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    localStorage.setItem('chamadoPage', newValue === 0 ? 'all' : newValue === 1 ? 'ticket' : 'allTickets');
    localStorage.removeItem('filtros');
    setTotalItens(10);
    setItensPerPage(10);
    setPageNumber(0);
    trackEventMatomo('minhas notificações', 'click', 'tab', 'muda aba');
  };

  const { t } = useTranslation('translation');

  useEffect(() => {
    const recoveredState = localStorage.getItem('chamadoPage');
    if (recoveredState) {
      setValue(recoveredState[0] === 'a' ? 0 : recoveredState[0] === 't' ? 1 : 2);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gerente = userData.role === 'Gestor' || userData.role === 'Gerente';
  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          textColor="secondary"
          indicatorColor="secondary"
          value={value} onChange={handleChange} >
          <Tab label={t('notifications.all.tabtitle')} value={0} />
          <Tab label={t('notifications.ticket.tabtitle')} value={1} />
          <Tab label={t('notifications.requester.tabTitle')} value={2} />
          {gerente && <Tab label={t('notifications.all.allcalls')} value={3} />}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <AllNotifications />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <MyTickets />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Solicitante />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <AllTickets />
      </CustomTabPanel>
    </>
  );
}
